import { useState } from "react";
import FeedbackForm from "./components/feedbackForm";
import FeedbackList from "./components/feedbackList";
import "./index.scss";

const FeedbackWeb = () => {
  const [tabKey, setTabKey] = useState(0);

  const changeTab = (curTab) => {
    if (curTab === tabKey) return;
    setTabKey(curTab);
  };

  return (
    <div className="feedback-web-wrapper">
      <div className="content-full">
        <div className="tab-wrapper">
          <div
            onClick={() => {
              changeTab(0);
            }}
            className={`tab-item ${tabKey === 0 ? "active" : ""}`}
          >
            意见反馈
          </div>
          <div className="space"></div>
          <div
            onClick={() => {
              changeTab(1);
            }}
            className={`tab-item ${tabKey === 1 ? "active" : ""}`}
          >
            反馈历史
          </div>
        </div>
        {
          tabKey === 1 ? <FeedbackList /> : <FeedbackForm setTabKey={setTabKey} />
        }
      </div>
    </div>
  );
};

export default FeedbackWeb;
